<template>
  <div class="Config pa-2">
    <v-app-bar
      app
      dark
      fixed
      style="background-color: var(--color-primary) !important"
    >
      <template v-slot:img="{ props }">
        <v-img v-bind="props" color="primary"></v-img>
      </template>

      <v-toolbar-title class="font-sahel">{{
        $t("nav-settings")
      }}</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn icon @click="logout">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on"> mdi-logout </v-icon>
          </template>
          <span>{{ $t("nav-logout") }}</span>
        </v-tooltip>

        <v-tooltip> </v-tooltip>
      </v-btn>

      <!-- <v-btn icon>
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn> -->
    </v-app-bar>

    <box :title="$t('nav-settings')">
      <div class="">
        <v-tabs v-model="selectedTab" class="bg-gray-100 pa-0_15" show-arrows>
          <v-tab href="#Config" class="justify-right">
            <v-icon> mdi-cogs </v-icon>
            تنظیمات اصلی سامانه
          </v-tab>
          <v-tab
            :disabled="!UpdateTabEnabled"
            href="#Update"
            class="justify-right"
          >
            <v-icon> mdi-update </v-icon>
            بروز رسانی
          </v-tab> 
          <v-tab
            v-if="PageAccessVisible"
            href="#PageAccess"
            disabled
            class="justify-right"
          >
            <v-icon> mdi-lock </v-icon>
            بروز رسانی دسترسی ها
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="selectedTab" class="">
          <v-tab-item value="Config" class="">
            <div class="">
              <basic-system-settings :config="config" />
            </div>
          </v-tab-item>
          <v-tab-item value="Update">
            <div class="">
              <update-settings
                :LockActivationEnabled="LockActivationEnabled"
                :LockDeactivationEnabled="LockDeactivationEnabled"
                @RefreshTabs="pageLoad"
              />
            </div>
          </v-tab-item>
          <v-tab-item value="PageAccess">
            <div class="">
              <page-access />
            </div>
          </v-tab-item>
        </v-tabs-items>
      </div>
    </box>
  </div>
</template>

<script>
import BasicSystemSettings from "../../components/config/BasicSystemSettings.vue";
import PageAccess from "../../components/config/PageAccess.vue";
import UpdateSettings from "../../components/config/UpdateSettings.vue";
import ResultType from "../../model/ResultType";
export default {
  components: { BasicSystemSettings, UpdateSettings, PageAccess },
  data() {
    return {
      PageAccessVisible: false,
      selectedTab: "",
      config: {},
      UpdateTabEnabled: false,
      LockActivationEnabled: false,
      LockDeactivationEnabled: false,
    };
  },
  mounted() {},
  created() {
    this.pageLoad();
  },
  methods: {
    async pageLoad() {
      var canConnect = false;
      var canConnectRes = await this.$store.dispatch("EosTestPass");
      //debugger
      if (canConnectRes.type === ResultType.success) {
        canConnect = true;
      }

      var PersonnelNo = this.$store.state.auth.auth.username;
      if (PersonnelNo != "000" && canConnect) {
        this.$store.dispatch("logout");
        //console.log(canConnect);
      }

      this.loadConfig();
      this.updateLockTabs(canConnect);
    },
    loadConfig() {
      this.$store.dispatch("loadConfig").then((result) => {
        //console.log(result);
        //debugger
        if (result.type === ResultType.success) {
          this.config = result.data;
        }
      });
    },
    async updateLockTabs() {
      //debugger
      this.selectedTab = "Config";
      /*var promises = [];
      var canActive = null;
      var canDeactive = null;

      promises.push(this.$store.dispatch("canActiveLock"));
      promises.push(this.$store.dispatch("canDeActiveLock"));

      Promise.all(promises).then((result) => {
        var canActiveLockResult = result[0];
        if (canActiveLockResult.type == ResultType.success) {
          canActive = canActiveLockResult.data;
        }

        var canDeactiveResult = result[1];
        if (canDeactiveResult.type == ResultType.success) {
          canDeactive = canDeactiveResult.data;
        }

        this.UpdateTabEnabled = canConnect || canActive || canDeactive;
        this.LockActivationEnabled = canActive;
        this.LockDeactivationEnabled = canDeactive;
      });*/
      var isLockActiveRes = await this.$store.dispatch("lock/IsLockActive");
      if (isLockActiveRes.type == ResultType.success) {
        //debugger
        if (!isLockActiveRes.data) {
          //this.lblError = "قفل وینکارت فعال نیست";
          this.UpdateTabEnabled = false;
        } else{
          this.UpdateTabEnabled = true
        }
      } else {
        //this.lblError = " خطا در خواندن قفل ";
        this.UpdateTabEnabled = false;
      }

      
    },
    logout() {
      //debugger
      this.$store.dispatch("logout");
    },
  },
};
</script>

<style>
.justify-right {
  justify-content: right !important;
}
.pa-0_15 {
  padding: 0.15rem;
}

.v-tab {
  min-width: 30px !important;
  margin: 0px;
  padding: 8px;
}
</style>